import { render, staticRenderFns } from "./Member.vue?vue&type=template&id=afa1aef6&scoped=true"
import script from "./Member.vue?vue&type=script&lang=js"
export * from "./Member.vue?vue&type=script&lang=js"
import style0 from "./Member.vue?vue&type=style&index=0&id=afa1aef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa1aef6",
  null
  
)

export default component.exports